export const capitalize = (value: string) => {
  return value.replace(/(^|\s)\p{L}/gu, (c) => c.toUpperCase());
};
